/**
 *
 * Setting
 *
 */

import { mapActions, mapState, mapGetters } from 'vuex';
import $ from 'jquery';
import Swal from 'sweetalert2';

import TrackerButton from '@/components/TrackerButton.vue';
import SharedHeader from '@/components/SharedHeader.vue';
import Footer from '@/components/Footer.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Aside from '@/components/Aside.vue';
import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import { MobileMixin } from '@/mixins/Mobile';
import { SettingMixin } from '@/mixins/Setting';
import { QaSendSmsNotificationMixin } from '@/mixins/Setting/QaSendSmsNotification';
import { AddressEditContainerMixin } from '@/mixins/AddressEdit/AddressEditContainer';
import { DEFAULT_DATA_URL, REDIRECT_URLS } from '@/constants/index';
import { IDENTITY_PAGE } from '@/constants/routes';
import { LOADING_MESSAGE } from './Setting.constants';

export default {
  name: 'Setting',

  mixins: [MobileMixin, SettingMixin, QaSendSmsNotificationMixin, AddressEditContainerMixin],

  components: {
    SharedHeader,
    Footer,
    TabBar,
    WayFindBar,
    Aside,
    Spinner,
    TrackerButton,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
      urlIdentity: IDENTITY_PAGE,
      avatar: DEFAULT_DATA_URL,
      avatarModal: DEFAULT_DATA_URL,
      avatarDataUrl: DEFAULT_DATA_URL,
      isAvatarTooLarge: false,
      isAvatarReady: false,
      errMessageAvatar: '',
      //
      gender: -1,
      //
      stepSetPassword: '',
      //
      errMessageBindWechat: '',
      params: null,
      ////
      password1: '',
      password2: '',
      passwordNotSame: false,
      //
      origPassword: '',
      newPassword1: '',
      newPassword2: '',
      newPasswordNotSame: false,
      errMessagePassword: '',
    };
  },

  computed: {
    ...mapState({
      ms_isWechatBrowser: (state) => state.browserInfo.isWechatBrowser,
    }),

    ...mapState('Setting', {
      ms_isRequest: 'isRequest',
      ms_qrcodeStatus: 'qrcodeStatus',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
      mg_identificationStatus: 'identificationStatus',
    }),

    c_isShowSpinner() {
      return this.$route.query.code || this.ms_isRequest || this.ms_setting_mixin_isRequest;
    },

    c_isNicknameReady() {
      return this._c_isNicknameReady && this.mg_userInfo.nickname !== this.nickname;
    },

    c_isSetEmailDisabled() {
      return !this.c_isEmailReady || (!this.c_hasPassword && !this.c_isNewPasswordReady);
    },

    ////
    c_isBindEmailReady() {
      if (
        !this.email ||
        this.c_isEmailInvalid ||
        !this.password1 ||
        !this.password2 ||
        this.passwordNotSame
      ) {
        return false;
      }
      return true;
    },

    c_isNewPasswordReady12() {
      if (
        !this.origPassword ||
        !this.newPassword1 ||
        !this.newPassword2 ||
        this.newPasswordNotSame
      ) {
        return false;
      }
      return true;
    },
  },

  methods: {
    ...mapActions({
      ma_getUserInfo: 'getUserInfo',
      ma_logout: 'logout',
    }),

    ...mapActions('Setting', {
      ma_updateavatar: 'updateavatar',
      ma_updateNicknameGender: 'updateNicknameGender',
      ma_checkMobile: 'checkMobile',
      ma_editPassword: 'editPassword',
      ma_unbindWechat: 'unbindWechat',
      //
      ma_checkBindQrcode: 'checkBindQrcode',
      ////
      ma_bindEmail: 'bindEmail',
      ma_updatePassword: 'updatePassword',
      ma_updatWechat: 'updatWechat',
    }),

    //
    handleClickAvatarBtn() {
      this.$refs.avatarInput.click();
    },

    handleChangeAvatar() {
      this.errMessageAvatar = '';
      const fileReader = new FileReader();
      const file = this.$refs.avatarInput.files[0];
      this.isAvatarTooLarge = file.size > 5 * 1024 * 1024;
      fileReader.readAsDataURL(file);
      fileReader.onload = (e) => {
        this.avatarDataUrl = e.target.result;
        this.avatarModal = this.avatarDataUrl;
      };
      this.isAvatarReady = !(
        undefined === this.$refs.avatarInput ||
        0 === this.$refs.avatarInput.files.length ||
        this.isAvatarTooLarge
      );
    },

    async updateavatar() {
      if (!this.isAvatarReady) {
        return;
      }
      const formData = new FormData();
      formData.append('file', this.$refs.avatarInput.files[0]);
      const res = await this.ma_updateavatar({
        formData,
        avatar: this.avatarDataUrl,
      });
      if (res.data.data) {
        this.avatar = this.avatarDataUrl;
        this.$refs.cancelAvatar.click();
      } else {
        this.errMessageAvatar = res.data.message;
      }
      this.$refs.avatarForm.reset();
    },

    //
    async updateNicknameGender() {
      if (!this.c_isNicknameReady) {
        return;
      }
      const res = await this.ma_updateNicknameGender({
        nickname: this.nickname,
        gender: this.gender,
      });
      if (res.data.data) {
        this.$refs.cancelNickname.click();
      } else {
        this.errMessageNickname = res.data.message;
      }
    },

    //
    openAddEmail() {
      this.email = '';
      this.errMessageEmail = '';
      this.newPassword = '';
    },

    async setEmail() {
      if (this.c_isSetEmailDisabled) {
        return;
      }
      const res = await this.ma_prepurchaseFromWechat({
        email: this.email,
        password: !this.c_hasPassword ? this.newPassword : undefined,
      });
      if (res.data.status != 200) {
        this.errMessageEmail = res.data.message;
      } else {
        this.$refs.cancelSetEmail.click();
      }
    },

    //
    openSetPassword() {
      this.mobileCode = '';
      this.newPassword = '';
    },

    async checkMobile() {
      const res = await this.ma_checkMobile({
        smsCode: this.mobileCode,
      });
      if (200 === res.data.status) {
        this.stepSetPassword = 'setPassword';
      } else {
        this.errMessageMobileCode = res.data.message;
      }
    },

    async setPassword() {
      if (!this.c_isNewPasswordReady) {
        return;
      }
      const res = await this.ma_editPassword({
        newPassword: this.newPassword,
      });
      if (200 === res.data.status) {
        this.$refs.cancelSetPassword.click();
        this.stepSetPassword = '';
      } else {
        this.errMessageNewPassword = res.data.message;
      }
    },

    openMobileModal() {
      this.getRegionNo();
    },

    //
    async checkWechatQrcode() {
      if (this.isQrCodeHandled) {
        return;
      }
      const res = await this.ma_checkBindQrcode(this.ms_wechatQrcodeInfo.wechatCode);
      if (this.isQrCodeHandled) {
        return;
      }
      //1  -1  -2  -3  分别代表 扫码成功  扫码失败  未扫码  二维码超时失效
      if (-2 === this.ms_qrcodeStatus) {
        return;
      }
      this.isQrCodeHandled = true;
      clearInterval(this.itvlcheckWechatQrcode);
      if (-3 === this.ms_qrcodeStatus) {
        this.isQrCodeHandled = 'timeout';
        return;
      }
      $('#synweichart').modal('hide');
      this.$refs.btnBindWechatSuccess.click();
      if (-1 === this.ms_qrcodeStatus) {
        this.errMessageBindWechat = res.data.message;
        return;
      }
      if (1 === this.ms_qrcodeStatus) {
        //
      }
    },

    async openWechatModal() {
      await this.getWechatQrcode();
      this.checkWechatQrcodeAndSetItvl();
    },

    //
    async logout() {
      await this.ma_logout();
      //this.$router.push(LANDING_PAGE);
      window.location.href = REDIRECT_URLS.LANDING_PAGE;
    },

    unBindWeChat() {
      this.ma_unbindWechat();
    },

    ////
    handleChangePassword() {
      if (!this.password1 || !this.password2) {
        return;
      }
      this.passwordNotSame = false;
      if (this.password1 !== this.password2) {
        this.passwordNotSame = true;
        return;
      }
    },

    async bindEmail() {
      if (!this.c_isBindEmailReady) {
        return;
      }
      const res = await this.ma_bindEmail({
        email: this.email,
        password: this.password1,
      });
      if (res.data.data) {
        this.$refs.cancelEmail.click();
      } else {
        this.errMessageEmail = res.data.message;
      }
    },

    handleChangeOrigPassword() {
      this.errMessagePassword = '';
    },

    handleChangeNewPassword12() {
      if (!this.newPassword1 || !this.newPassword2) {
        return;
      }
      this.newPasswordNotSame = false;
      if (this.newPassword1 !== this.newPassword2) {
        this.newPasswordNotSame = true;
        return;
      }
    },

    async updatePassword() {
      if (!this.c_isNewPasswordReady12) {
        return;
      }
      const res = await this.ma_updatePassword({
        oldPassword: this.origPassword,
        newPassword: this.newPassword1,
      });
      if (res.data.data) {
        this.$refs.cancelPassword.click();
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'success',
          title: '密码已修改',
          showConfirmButton: false,
          timer: 800,
        });
      } else {
        this.errMessagePassword = res.data.message;
      }
    },

    handleChangeWechat() {
      this.errMessageWechat = '';
    },

    async updatWechat() {
      if (!this.c_isWechatReady) {
        return;
      }
      const res = await this.ma_updatWechat({
        weChatNo: this.wechat,
      });
      if (res.data.data) {
        this.$refs.cancelWechat.click();
      } else {
        this.errMessageWechat = res.data.message;
      }
    },
  },

  async created() {
    this.getStudentAddress();
    await this.ma_getUserInfo();
    this.avatar = this.mg_userInfo.avatar;
    this.avatarModal = this.mg_userInfo.avatar;
    this.nickname = this.mg_userInfo.nickname;
    this.gender = this.mg_userInfo.gender;
  },
};
